import { useParams } from "react-router-dom";
import { useGetOrganizationCommunityRoutes } from "../../services/ContentManager";
import { useSnackbar } from "notistack";
import { useQueryClient } from "react-query";
import NTMXGrid from "../../components/NTMXGrid";
import React, { useState } from "react";
import {
    COMMUNITY_ROUTES, DASH_ORGANIZATIONS, deleteElem, getErrorMessage, post, put
} from "../../services/Client";
import Grid from "@mui/material/Grid";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import StartIconButton from "../../components/buttons/StartIconButton";
import CommunityRouteModal from "../../components/modals/CommunityRouteModal";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

export default function CommunityRoutes() {

    const { t } = useTranslation();
    const { id } = useParams();
    const { communityRoutes, status } = useGetOrganizationCommunityRoutes(id);
    const { enqueueSnackbar } = useSnackbar();
    const queryClient = useQueryClient();

    const [modalOpen, setModalOpen] = useState(false);
    const [editing, setEditing] = useState(null);

    const base = DASH_ORGANIZATIONS;
    const elem = id + "/" + COMMUNITY_ROUTES;
    const key = [DASH_ORGANIZATIONS, { id: id }, COMMUNITY_ROUTES];

    const refresh = () => queryClient.invalidateQueries(key);
    const ok = () => enqueueSnackbar(t("saved"), { variant: "success" });
    const ko = (e) => enqueueSnackbar(getErrorMessage(e), { variant: "error" });

    const openCreate = () => { setEditing(null); setModalOpen(true); };
    const openEdit = (row) => { setEditing(row); setModalOpen(true); };
    const closeModal = () => setModalOpen(false);

    const handleSubmit = (payload) => {
        enqueueSnackbar(t("saving..."), { variant: "info" });
        let req;
        if (payload.mode === "update") {
            req = put(base, { elem: elem + "/" + editing.id, body: payload.body });
        } else if (payload.mode === "gpx") {
            req = post(base, { elem: elem + "/gpx", body: payload.formData });
        } else {
            req = post(base, { elem, body: payload.body });
        }
        req.then(ok).catch(ko).finally(() => { refresh(); closeModal(); });
    };

    const remove = (row) => {
        if (!window.confirm(t("confirmDeletion"))) return;
        deleteElem(base, { elem: elem + "/" + row.id }).then(ok).catch(ko).finally(refresh);
    };

    const columns = [
        { headerName: t("name"), field: "name", width: 200 },
        { headerName: t("description"), field: "description", width: 260 },
        { headerName: "km", field: "distance", width: 90 },
        { headerName: t("show"), field: "show", width: 90, renderCell: (p) => (p.value ? "✓" : "") },
        {
            headerName: t("creationDate"), field: "createdAt", width: 160,
            valueFormatter: ({ value }) => (value ? dayjs(value).format("DD/MM/YYYY HH:mm") : "")
        },
        {
            headerName: "", field: "actions", width: 110, sortable: false, filterable: false,
            renderCell: (p) => (
                <>
                    <IconButton size="small" onClick={() => openEdit(p.row)}><EditIcon fontSize="small" /></IconButton>
                    <IconButton size="small" onClick={() => remove(p.row)}><DeleteIcon fontSize="small" /></IconButton>
                </>
            )
        },
    ];

    return (
        <div>
            <NTMXGrid
                key="manager-community-routes"
                columns={columns}
                rows={communityRoutes || []}
                title={t("communityRoutes")}
                loading={status === "loading"}
                rightButton={
                    <Grid container justifyContent="flex-end">
                        <StartIconButton onClick={openCreate} title={t("create")} startIcon={<AddIcon />} />
                    </Grid>
                }
            />
            <CommunityRouteModal
                open={modalOpen}
                onClose={closeModal}
                onSubmit={handleSubmit}
                route={editing}
                organizationId={id}
            />
        </div>
    );
}
